import { useQuery } from '@tanstack/react-query';

import { apiGet } from '@/lib/http/client';
import {
  portfolioOrgMembersUrl,
  portfolioQueryKeys,
} from '@/lib/portfolio/api';
import type { PortfolioMember } from '@/lib/portfolio/types';

export function useOrgMembers(portfolioId: number, orgId: number) {
  return useQuery<PortfolioMember[]>({
    queryKey: portfolioQueryKeys.orgMembers(portfolioId, orgId),
    queryFn: () =>
      apiGet<PortfolioMember[]>(portfolioOrgMembersUrl(portfolioId, orgId)),
    enabled: Number.isFinite(portfolioId) && Number.isFinite(orgId),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
